import React from "react";
import {
  Box,
  ButtonBase,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Outlet } from "react-router-dom";
import { denseDashboardContentSx, responsiveCardSx } from "../../../theme/webProfitResponsive";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function MobileProjectSettingsLayout({
  project,
  activeModules,
  attentionItems = [],
  onAttentionOpen,
}) {
  return (
    <Stack spacing={1.05} sx={{ pb: 1.5 }}>
      <Typography
        variant="h4"
        sx={{ color: BRAND.dark, fontWeight: 950, lineHeight: 1.1, px: .1 }}
      >
        Configuración
      </Typography>

      {attentionItems.length ? (
        <Paper
          elevation={0}
          sx={{
            ...responsiveCardSx,
            p: 1,
            border: "1px solid rgba(237,108,2,.18)",
            bgcolor: "rgba(237,108,2,.025)",
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ mb: .65 }}>
            <Typography sx={{ color: BRAND.dark, fontWeight: 950, fontSize: 13.5 }}>
              {attentionItems.length === 1 ? "1 pendiente" : `${attentionItems.length} pendientes`}
            </Typography>
            <Chip
              size="small"
              variant="outlined"
              color="warning"
              label="Requiere atención"
              sx={{ height: 24, fontSize: 10.5, fontWeight: 900 }}
            />
          </Stack>

          <Stack spacing={.55}>
            {attentionItems.map((item) => (
              <ButtonBase
                key={item.key}
                onClick={() => onAttentionOpen?.(item)}
                aria-label={`${item.actionLabel}: ${item.title}`}
                sx={{
                  width: "100%",
                  minHeight: 48,
                  p: .75,
                  borderRadius: 2.2,
                  justifyContent: "flex-start",
                  textAlign: "left",
                  bgcolor: "#fff",
                  border: "1px solid rgba(25,36,47,.08)",
                  "&:focus-visible": {
                    outline: `3px solid rgba(243,90,58,.24)`,
                    outlineOffset: 1,
                  },
                }}
              >
                <Box sx={{ display: "grid", placeItems: "center", color: item.tone === "error" ? "error.main" : "warning.main", mr: .8 }}>
                  {item.icon}
                </Box>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography sx={{ color: BRAND.dark, fontWeight: 950, fontSize: 12.5, lineHeight: 1.2 }}>
                    {item.title}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ display: "block", mt: .2, color: "rgba(25,36,47,.57)", lineHeight: 1.25 }}
                  >
                    {item.description}
                  </Typography>
                </Box>
                <Typography sx={{ ml: .75, color: BRAND.orange, fontSize: 11, fontWeight: 950, whiteSpace: "nowrap" }}>
                  {item.actionLabel}
                </Typography>
              </ButtonBase>
            ))}
          </Stack>
        </Paper>
      ) : null}

      <Paper
        elevation={0}
        sx={{
          ...responsiveCardSx,
          ...denseDashboardContentSx,
          border: "1px solid rgba(25,36,47,.08)",
          bgcolor: "#FBFBFD",
          p: { xs: 1.15, sm: 1.5 },
        }}
      >
        <Outlet />
      </Paper>

      <Paper elevation={0} sx={{ p: 1.2, borderRadius: 3, border: "1px solid rgba(25,36,47,.08)" }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ color: BRAND.dark, fontWeight: 950, fontSize: 13.5 }}>
              {project?.name || "Proyecto"}
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(25,36,47,.55)" }}>
              {activeModules} módulos activos
            </Typography>
          </Box>
          <ChevronRightRoundedIcon sx={{ color: "rgba(25,36,47,.35)" }} />
        </Stack>
      </Paper>
    </Stack>
  );
}
